import React from 'react';
import ArrowButton from '../Common/ArrowButton';

interface HeaderChartProps {
  onBackClick?: () => void;
}

const HeaderChart: React.FC<HeaderChartProps> = () => {
  return (
    <div className="bg-white shadow-sm border-b border-gray-200 p-3 sm:p-4 md:p-6 flex items-center justify-center relative h-[70px] sm:h-[80px] md:h-[100px]">
      {/* Back Button */}
      <div className="absolute left-3 sm:left-4 md:left-6 top-1/2 -translate-y-1/2">
        <ArrowButton />
      </div>
      
      {/* Title - Responsive text sizes */}
      <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-center px-12 sm:px-16 md:px-20">
        <span className="text-navgreen">AO Smith</span>{' '}
        <span className="text-black">Org Chart</span>
      </h1>
    </div>
  );
};

export default HeaderChart;